import * as React from 'react'
import * as SentryNext from '@sentry/nextjs'
import { ErrorFallbackComponent } from './ErrorFallbackComponent'

export function ErrorBoundary(props: React.PropsWithChildren<object>) {
  return (
    <SentryNext.ErrorBoundary
      fallback={(props) => <ErrorFallbackComponent {...props} />}
    >
      {props.children}
    </SentryNext.ErrorBoundary>
  )
}
